import { AxiosError } from "axios";
import { useMutation } from "react-query";
import publicHttp from "../services/publicHttp";

/** `redirect_url` is the form's own redirect, `payment_status` added, or null when it has none. */
export interface RegistrationPaymentCheck {
  status: "paid" | "pending";
  payment_link: string | null;
  redirect_url: string | null;
}

export interface RegistrationPaymentReturn {
  entityId: string;
  formId: string;
  userId: string;
  sig: string;
}

/** The client back from paying a registration: the signature of the return link stands for the login. */
export const useCheckRegistrationPayment = () =>
  useMutation<
    RegistrationPaymentCheck,
    AxiosError<any>,
    RegistrationPaymentReturn
  >(async ({ entityId, formId, userId, sig }) => {
    const res = await publicHttp.post(
      `/${entityId}/registration-payment/${formId}/${userId}/check`,
      { sig }
    );
    return res?.data?.element;
  });
